import { axios } from 'utils/common';
import { OTPLoginType } from 'utils/constant';
import { aesEncrypt } from 'utils/common';

class AuthService {
  login(Username, Password) {
    const URL = `Authentications/login`;

    return axios({
      method: 'post',
      url: URL,
      data: { Username, Password: aesEncrypt(Password) }
    });
  }

  // login2faSendCode(Username, Password, Provider) {
  //   const URL = `Authentications/SendCode`;

  //   return axios({
  //     method: 'post',
  //     url: URL,
  //     data: { Username, Password: aesEncrypt(Password), Provider }
  //   });
  // }

  // login2faVerfiyCode(Username, Password, TwoFactorCode, Provider) {
  //   const URL = `Authentications/loginVerifCode`;

  //   return axios({
  //     method: 'post',
  //     url: URL,
  //     data: {
  //       Username,
  //       Password: aesEncrypt(Password),
  //       TwoFactorCode,
  //       Provider
  //     }
  //   });
  // }

  // loginOTP(loginType, loginData) {
  //   const URL = `Authentications/loginOTP`;

  //   return axios({
  //     method: 'post',
  //     url: URL,
  //     data: {
  //       Email: loginType === OTPLoginType.EMAIL ? loginData : '',
  //       PhoneNumber: loginType === OTPLoginType.MOBILE ? loginData : '',
  //       TwoFactorCode: '',
  //       Provider: loginType
  //     }
  //   });
  // }

  // loginOTPVerifyCode(loginType, loginData, TwoFactorCode) {
  //   const URL = `Authentications/loginOTPVerifyCode`;

  //   return axios({
  //     method: 'post',
  //     url: URL,
  //     data: {
  //       Email: loginType === OTPLoginType.EMAIL ? loginData : '',
  //       PhoneNumber: loginType === OTPLoginType.MOBILE ? loginData : '',
  //       TwoFactorCode,
  //       Provider: loginType
  //     }
  //   });
  // }
}
export default new AuthService();
